<template>
  <div class="station-cutting-panel-scan-page" @click="focusBarcodeEntry()">
    <StationAlertMessage ref="cuttingAlertMessage" />

    <div class="station-scanner-entry my-4">
      <h2 class="text-muted">Enter panel barcode to scan a panel as cut</h2>
      <FormInputText ref="panelBarcodeScan" v-model="barcodeEntry" placeholder="Barcode" @click="onScannedBarcodeClicked" @enter="onScannedBarcode()" prependSlot>
        <template v-slot:prepend>
          <i class="far fa-scanner"></i>
        </template>
      </FormInputText>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.station-cutting-panel-scan-page {
  flex: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items:stretch;
  overflow-x: hidden;
}
</style>


<script>
import _ from 'lodash'
import moment from 'moment'

import formMixin from '@/mixins/form'
import Utils from '@/utils/utils'
import EventBus from '@/utils/eventBus'
import StationAlertMessage from '@/apps/glass-production-station/src/components/station/stationAlertMessage'
import StationScanWarningDialog from '@/apps/glass-production-station/src/views/stationScanWarningDialog'

import { LinkTypes, DespatchTypeLookup } from '@/store/types'

export default {
  name: 'CuttingPanelScanPage',
  mixins: [formMixin],
  components: {
    StationAlertMessage
  },
  props: {
    productionStage: Object,
    productionStation: Object
  },
  data() {
    return {
      // Panel Scan
      barcodeEntry: '',
      panelDetails: {
        barcode: '',
        nextStage: '',
        nextStageColour: '#400000',
        tasksComplete: false,
        despatchType: ''
      },
    }
  },
  created() {
    this.DespatchTypeLookup = DespatchTypeLookup
  },
  mounted() {
    this.$refs.panelBarcodeScan.select()
    this.$refs.panelBarcodeScan.focus()

    EventBus.on(EventBus.EventTypes.panelLabelPrinted, this.focusBarcodeEntry)
  },
  beforeDestroy() {
    EventBus.off(EventBus.EventTypes.panelLabelPrinted, this.focusBarcodeEntry)
  },
  methods: {
    onScannedBarcode(options = {}) {
      if(this.barcodeEntry.trim().length == '') {
        this.barcodeEntry = ''
        return
      }

      var scanData = {
        barcode: this.barcodeEntry
      }
      if(options)
        scanData = _.merge(scanData, options)

      // Run the scan in/out function on the panel scanned
      this.$apiService.glassProductionStationService.runPanelBarcodeScan(this.productionStation.id, scanData)
      .then(response => {
        let barcode = response.data.panelBarcode
        var nextStage = ''

        if(response.data.panelTaskCompleted) {
          if(response.data.nextStage && response.data.nextStage.productionStage) {
            nextStage = response.data.nextStage.productionStage.name
          }
        }

        if(response.data.tasksComplete) {
          var despatchName = Utils.getLookupName(DespatchTypeLookup, response.data.despatchType)
          this.$refs.cuttingAlertMessage.displayAlert('success', 'Panel Cut', `Panel ${barcode} has finished processing and is due at <strong>despatch</strong> for <strong>${despatchName}</strong>`)
        } else {
          if(response.data.panelTaskStarted)
            this.$refs.cuttingAlertMessage.displayAlert('success', 'Panel Scanned In', `Panel ${barcode} added`)
          else if(response.data.panelTaskCompleted)
            this.$refs.cuttingAlertMessage.displayAlert('success', 'Panel Cut', `Panel ${barcode} is next due at <strong>${nextStage}</strong>`)
        }

        // Back to scanning
        this.barcodeEntry = ''
        this.$refs.panelBarcodeScan.focus()
      })
      .catch(err => {
        let errorInfo = this.processFormResponse(err)

        // If the server gives warnings + override, display the override warning dialog
        if(errorInfo.errorData && errorInfo.errorData.overrideWarningOptions && errorInfo.errorData.overrideWarningOptions.available) {

          // Show warning override options
          this.displayModal(StationScanWarningDialog, { 
            productionStageId: this.productionStage.id,
            productionStationId: this.productionStation.id,
            overrideWarningOptions: errorInfo.errorData.overrideWarningOptions,
          })
          .then((result) => {

            if(result) {
              // Attempt to scan again with override specified
              this.$nextTick(() => {
                this.onScannedBarcode({ overrideWarnings: true, overrideName: result.name })
              })
            }
          })          
          return
        }

        this.$refs.cuttingAlertMessage.displayAlert('error', 'Scanning Error!', errorInfo.errorMessage)          

        // Back to scanning
        this.barcodeEntry = ''
        this.$refs.panelBarcodeScan.focus()
      })
    },
    onScannedBarcodeClicked() {
      this.$refs.panelBarcodeScan.select()
    },
    focusBarcodeEntry() {
      // Ignore if a modal dialog if open
      if(this.isDocumentModalVisible())
        return

      this.$refs.panelBarcodeScan.select()
    },
    // Page Selected - Called when this cutting panel scan page is selected to be shown
    pageSelected() {
      this.$refs.cuttingAlertMessage.hide()

      this.barcodeEntry = ''
      this.$nextTick(() => {
        this.$refs.panelBarcodeScan.focus()
      })
    }
  }
}
</script>